module.exports = __webpack_public_path__ + "img/icon_profi_zahnreinigung.5010eeaf.svg";